<script lang="ts">
  import { getContext } from 'svelte';
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import { Image } from '../../image';
  import type { CardImageProps } from '../card.types';

  const { src, alt = '', css: cssProp, crop = false, width = 800, height, background, children, aspectRatio = 16 / 9, loading = 'lazy', fit = 'cover', fetchpriority = 'auto', ...props }: CardImageProps = $props();

  const { imageBg } = getContext<{ imageBg: boolean }>('card');

  const classes = cardStyles.raw({ imageBg });
</script>

{#if src}
  <Image
    src={src}
    width={width}
    height={height}
    background={background}
    aspectRatio={aspectRatio}
    fetchpriority={fetchpriority}
    fit={fit}
    alt={alt}
    css={{...classes.image, ...cssProp}}
    loading={loading}
  />
{:else if children}
  <div class={cx(css(classes.image), css(cssProp))} {...props}>
    {@render children()}
  </div>
{/if}
